import LogoGenerator from '@utils/logo-generator'

class PortalAvatar {
  text: string

  constructor(text?: string) {
    this.text = text || ''
  }

  get Avatar() {
    return LogoGenerator.getLogoDataUrl({ text: this.text, pattern: 'space-invaders' })
  }

}

export default PortalAvatar
